import clsx from 'clsx';
import React, { PropsWithChildren, useMemo } from 'react';

export interface ListItem {
  _id: string;
  selected: string;
  onClick: (e: any) => void;
}

export function ListItem({ _id, selected, onClick, children }: PropsWithChildren<ListItem>) {
  const highlight = useMemo(() => selected === _id, [_id, selected]);
  return (
    <tr
      className={clsx(
        'border-gray-20 cursor-pointer transition-colors duration-150',
        'hover:bg-gold',
        'focus:outline-none focus-visible:ring',
        highlight ? 'bg-gold cursor-pointer font-semibold border-b-2 border-primary-500' : 'border-b'
      )}
      onClick={onClick}
      tabIndex={highlight ? 0 : -1}
      aria-selected={Boolean(highlight)}
    >
      {children}
    </tr>
  );
}

export default ListItem;
